import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

const AsyncFeatureFlags = Load(
  () =>
    import(/* webpackChunkName: "feature-flags" */ './components/FeatureFlags'),
  {},
  true,
);

export const featureFlagsRoute: RouteDescriptor = {
  id: 'feature-flags.overview',
  path: `${basePath}/feature-flags`,
  label: 'Feature Flags',
  audience: 'both',
  layout: 'navigational',
  module: 'feature-flags',
};

export const featureFlagsRoutes = [
  createNavigationalRoute({
    key: featureFlagsRoute.id,
    id: featureFlagsRoute.id,
    path: featureFlagsRoute.path,
    component: AsyncFeatureFlags,
    handle: createRouteHandle(featureFlagsRoute),
    nonFixedNavbar: true,
  }),
];

export const featureFlagsRouteDescriptors = [featureFlagsRoute];

export default featureFlagsRoutes;
